import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';
import { SaleOrderDeparture } from '../sale-order-departure';
import { parseNumber } from '../../utils/number.utils';
import { SaleOrderDepartureSerialNumberBuilder } from './sale-order-departure-serial-number.builder';

export class SaleOrderDepartureBuilder {
  static fromJson(json): SaleOrderDeparture {
    return (json) ? new SaleOrderDeparture(
      json.hash,
      parseNumber(json.departureDate),
      json.authorizingPersonHash,
      json.authorizingPersonName,
      json.requestMadeByHash,
      json.requestMadeByName,
      json.saleOrderDepartureReasonHash,
      json.saleOrderDepartureReasonName,
      json.observations,
      (isArray(json.saleOrderDepartureSerialNumbers)) ?
        SaleOrderDepartureSerialNumberBuilder.fromJsonList(json.saleOrderDepartureSerialNumbers) : [],
      parseNumber(json.duration),
      parseNumber(json.durationDate)
    ) : null;
  }

  static fromJsonList(list): SaleOrderDeparture[] {
    return (isArray(list)) ? mapCollection(SaleOrderDepartureBuilder.fromJson, list) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-departure-builder.ts